import AnchoringBiasSimulation from './anchoring';
import GamblersFallacySimulation from './gamblers-fallacy';
import SunkCostFallacySimulation from './sunk-cost';
import ConfirmationBiasSimulation from './confirmation-bias';
import TemplatedRosyRetrospectionSimulation from './rosy-retrospection/TemplatedSimulation';
import SurvivorshipBiasSimulation from './survivorship-bias';
import FalseConsensusSimulation from './false-consensus';
import AvailabilityHeuristicSimulation from './availability';
import DunningKrugerSimulation from './dunning-kruger';
import StatusQuoBiasSimulation from './status-quo';
import HindsightBiasSimulation from './hindsight-bias';
import BaseRateFallacySimulation from './base-rate-fallacy';

export const simulations: { [key: string]: React.FC } = {
  'AnchoringBiasSimulation': AnchoringBiasSimulation,
  'GamblersFallacySimulation': GamblersFallacySimulation,
  'SunkCostFallacySimulation': SunkCostFallacySimulation,
  'ConfirmationBiasSimulation': ConfirmationBiasSimulation,
  'RosyRetrospectionSimulation': TemplatedRosyRetrospectionSimulation,
  'SurvivorshipBiasSimulation': SurvivorshipBiasSimulation,
  'FalseConsensusSimulation': FalseConsensusSimulation,
  'AvailabilityHeuristicSimulation': AvailabilityHeuristicSimulation,
  'DunningKrugerSimulation': DunningKrugerSimulation,
  'StatusQuoBiasSimulation': StatusQuoBiasSimulation,
  'HindsightBiasSimulation': HindsightBiasSimulation,
  'BaseRateFallacySimulation': BaseRateFallacySimulation
}; 